<app-balance-filters
  [shippingAddressGroup]="shippingAddressGroup"
  (searchSubmitted)="getFilters($event)"
  >
</app-balance-filters>
@if (items && items.length) {
  <div class="row">
    <div class="col-md-12">
      <!-- Number of results -->
      <div class="numResults">
        @if (filters.options.company_id_filter || ( (applicationService.checkIfDealerHasCompany(101) && !applicationService.checkIfDealerHasCompany(102)) || (!applicationService.checkIfDealerHasCompany(101) && applicationService.checkIfDealerHasCompany(102)))) {
          <app-invoice-balance-overview
            [numResults]="balanceData"
          ></app-invoice-balance-overview>
        }
      </div>
    </div>
  </div>
}
<div class="mb-4 mt-1 tableContainer customScrollbar">
  @if (items && items.length) {
    <span>{{ 'SHOWS_INVOICES_FROM' | translate}}: <strong>{{formattedDateFrom}}</strong> {{ 'TILL' | translate }} <strong>{{formattedDateTo}}</strong></span>
  }
  <table class="table">
    <thead>
      @if (items && items.length) {
        <tr class="financial-item">
          <td style="max-width: 30px;"></td>
          <td>{{ "INVOICE_NUMBER" | translate }}</td>
          <td>{{ "INVOICE_DATE" | translate }}</td>
          <td>{{ "DUE_DATE" | translate }}</td>
          <td>{{ "INVOICE_AMOUNT" | translate }}</td>
          <td>{{ "AMOUNT_DUE" | translate }}</td>
          <td>{{ "DISCOUNT_DUE_DATE" | translate }}</td>
          <td>{{ "INVOICE_PDF" | translate }}</td>
          <td>{{ "ORDERNUMBER" | translate }} Accentry</td>
        </tr>
      }
      @if (items && !items.length) {
        <tr>
          <td class="border-0">
            <app-no-results></app-no-results>
          </td>
        </tr>
      }
    </thead>
    <tbody>
      @for (invoice of items; track invoice; let rowIndex = $index) {
        <app-balance-line
          class="w-100 d-block d-table-row small financial-item"
          [invoice]="invoice"
          [attr.data-index]="rowIndex + 1"
          [ngbTooltip]="invoice | shippingAddressText"
          (invoiceSelectionChange)="getSelection()"
          >
        </app-balance-line>
      }
    </tbody>

    @if (!loaded) {
      <ngx-skeleton-loader count="20" appearance="line" [theme]="{height: '80px' }">
      </ngx-skeleton-loader>
    }
  </table>
  @if (page < totalPages && !keyWord) {
    <button class="btn btn-dark btn-block" (click)="showMore()">{{"SHOW_MORE"|translate}}</button>
  }
</div>
